// const checkSameCoordinatesTemp = (firstCoords, currentCoords) => {
//   const variance = 0.000001;

//   const [firstPointLat, firstPointLng] = firstCoords;
//   const [currentPointLat, currentPointLng] = currentCoords;

//   const differenceLat = Math.abs(currentPointLat - firstPointLat);
//   const differenceLng = Math.abs(currentPointLng - firstPointLng);

//   // if difference is less than variance than it is a same co-ordinate
//   if (differenceLat <= variance && differenceLng <= variance) {
//     return true;
//   }

//   // not a same co-ordinate
//   return false;
// };

const checkSameCoordinates = (firstCoords, currentCoords) => {
  const toRadians = (deg) => (deg * Math.PI) / 180;
  const EARTH_RADIUS = 6371000; // (meters)

  const [lat1, lon1] = firstCoords;
  const [lat2, lon2] = currentCoords;

  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = EARTH_RADIUS * c;

  // distance less than 5 meters
  return distance < 5;
};

export default checkSameCoordinates;
